import { render, staticRenderFns } from "./full-screen.vue?vue&type=template&id=63d1141c&scoped=true"
import script from "./full-screen.vue?vue&type=script&lang=js"
export * from "./full-screen.vue?vue&type=script&lang=js"
import style0 from "./full-screen.vue?vue&type=style&index=0&id=63d1141c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d1141c",
  null
  
)

export default component.exports